import {useEffect} from 'react';
import {useSelector} from 'react-redux';

import {amplitude} from '../../../../services/amplitude';
import cryptoService from '../../../../services/cryptoService';
import {selectConsumerId} from '../../../../state/selectors/consumer';

const useAmplitudeUserId = () => {
    const consumerId = useSelector(selectConsumerId);

    useEffect(() => {
        if (!consumerId) return;

        const hashedConsumerId = cryptoService.hashMD5(consumerId);

        amplitude.setAmplitudeUserId(hashedConsumerId);
    }, [consumerId]);
};

export default useAmplitudeUserId;
